import type { TranslationKey } from './translations/en';

const STATUS_KEY_MAP: Record<string, TranslationKey> = {
  paid: 'status.paid',
  due: 'status.due',
  scheduled: 'status.scheduled',
  active: 'status.active',
  seized: 'status.seized',
  closed: 'status.closed',
};

export function translateStatus(
  status: string,
  t: (key: TranslationKey | string) => string
): string {
  const key = STATUS_KEY_MAP[String(status || '').toLowerCase()];
  return key ? t(key) : status;
}
